import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillEye, AiFillDelete } from "react-icons/ai";
import { FiGlobe } from "react-icons/fi";
import { apiPut, apiDelete } from "../../utils/apiFetch";
import { useTranslation } from "react-i18next";
import { useState, useContext } from "react"; // Added useContext
import dayjs from "dayjs";
import apiPath from "../../utils/pathObj";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";
import { BsArrowUpShort } from "react-icons/bs";
import StaffIpModal from "components/geoAccess/StaffIpModal";
import AuthContext from "context/AuthContext"; // Added AuthContext

const HROnboardingList = ({ onboardingList, page, allOnboarding, handleEdit, handleView, sort, setSort }) => {
  const notification = useToastContext();
  const { t } = useTranslation();
  const { fetchCompanyCompletionStatus } = useContext(AuthContext); // Added fetchCompanyCompletionStatus
  const [ipItem, setIpItem] = useState(null);

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.onboardingStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allOnboarding();
        if (fetchCompanyCompletionStatus) fetchCompanyCompletionStatus(); // Refresh status
      }
    } catch (error) {
      console.log("error in get all country list==>>>>", error.message);
    }
  };

  const handleDeleteHR = async (id) => {
    try {
      const path = `${apiPath.onboardingDelete}/${id}`;
      const result = await apiDelete(path);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allOnboarding({ deletePage: true });
        if (fetchCompanyCompletionStatus) fetchCompanyCompletionStatus(); // Refresh status
      }
    } catch (error) {
      console.log("error in delete HR==>>>>", error.message);
    }
  };

  return (
    <div>
      <div className="p-3">
        <div className="border overflow-x-auto relative rounded-lg ">
          <table className="dark:text-gray-400 w-full text-xs text-left text-[#A5A5A5] ">
            <thead className="bg-[#E1E6EE] text-xs text-gray-900 border border-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th className="px-6 py-3" scope="col">
                  Sr no.
                </th>
                <th scope="col" className="px-6 py-3">
                  {t("HR_ID")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("HR_NAME")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("MOBILE_NUMBER")}
                </th>
                <th
                  scope="col"
                  className="cursor-pointer py-3 px-6 "
                  onClick={() => {
                    if (sort.sortBy === "email" && sort.sortType === "asc") {
                      setSort({
                        sortType: "desc",
                        sortBy: "email",
                      });
                    } else {
                      setSort({
                        sortType: "asc",
                        sortBy: "email",
                      });
                    }
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("EMAIL_ID")}</span>
                    <span>
                      {sort.sortType === "asc" && sort.sortBy === "email" && <BsArrowUpShort className="h-4 w-4 " />}
                      {sort.sortBy === "email" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                    </span>
                  </div>
                </th>
                <th
                  className="cursor-pointer py-3 px-6 "
                  scope="col"
                  onClick={() => {
                    if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                      setSort({
                        sortType: "desc",
                        sortBy: "createdAt",
                      });
                    } else {
                      setSort({
                        sortType: "asc",
                        sortBy: "createdAt",
                      });
                    }
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("CREATED_DATE")}</span>
                    <span>
                      {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                      {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 rotate-180 h-4 " />}
                    </span>
                  </div>
                </th>
                <th className="py-3 text-center px-6 " scope="col">
                  {t("O_STATUS")}
                </th>
                <th scope="col" className="text-center py-3 px-6 ">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {onboardingList &&
                onboardingList.map((item, i) => {
                  return (
                    <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      <td className="py-4 px-6 border-r text-gray-900">{item?.hrId}</td>
                      <td className="border-r py-4 px-6 text-gray-900">{item?.name}</td>
                      <td className="px-6 border-r py-4 text-gray-900">
                        +({item?.countryCode}) {item?.mobile}
                      </td>
                      <td className="text-gray-900 py-4 px-6 border-r ">{item?.email}</td>
                      <td className="text-left py-4 px-6 border-r text-gray-900 ">{dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")} </td>
                      <td className="text-center py-4 px-6 border-r text-gray-900 ">
                        <label title={`${item?.status === "active" ? "Active" : "Inactive"}`} className="relative inline-flex items-center cursor-pointer">
                          <input
                            onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, item, handelStatusChange)}
                            type="checkbox"
                            className="sr-only peer"
                            checked={item?.status === "active"}
                          />
                          <div className="peer-focus:ring-0 w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                        </label>
                      </td>
                      <td className="py-4 px-6 border-l text-gray-900">
                        <div className="">
                          <ul className="flex justify-center">
                            <li className="hover:bg-white px-2 py-2 hover:text-LightBlue" onClick={() => handleEdit(item)}>
                              <a title="Edit" data-bs-toggle="tooltip" className="transition hover:text-blue-700 duration-150 ease-in-out">
                                {" "}
                                <AiFillEdit className="w-5 h-5 cursor-pointer text-slate-600" />
                              </a>
                            </li>
                            <li className="py-2 px-2 hover:bg-white hover:text-LightBlue" onClick={() => setIpItem(item)}>
                              <a title={t("GEO_MANAGE_IPS")}>
                                <FiGlobe className="w-5 h-5 cursor-pointer text-slate-600" />
                              </a>
                            </li>
                            <li className="py-2 px-2 hover:bg-white hover:text-LightBlue" onClick={() => handleView(item)}>
                              <a title="View">
                                {" "}
                                <AiFillEye className="text-slate-600 cursor-pointer w-5 h-5 " />{" "}
                              </a>
                            </li>
                            <li
                              onClick={() => {
                                helper.alertFunction(
                                  `Are you sure you want to delete HR '${item?.name}'?`,
                                  item?._id,
                                  handleDeleteHR,
                                  true
                                );
                              }}
                              className="px-2 py-2 hover:bg-white hover:text-red-500 cursor-pointer"
                            >
                              <a title={t("O_DELETE_USER")}>
                                <AiFillDelete className="w-5 h-5 text-slate-600 hover:text-red-600" />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(onboardingList) ? (
                <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 border-r" colSpan={8}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
      {ipItem && (
        <StaffIpModal
          item={ipItem}
          role="HRAdmin"
          title={t("GEO_SECTION_HR")}
          onClose={() => setIpItem(null)}
        />
      )}
    </div>
  );
};

export default HROnboardingList;


// import useToastContext from "hooks/useToastContext";
// import { AiFillEdit, AiFillEye, AiFillDelete } from "react-icons/ai";
// import { FiGlobe } from "react-icons/fi";
// import { apiPut, apiDelete } from "../../utils/apiFetch";
// import { useTranslation } from "react-i18next";
// import { useState } from "react";
// import dayjs from "dayjs";
// import apiPath from "../../utils/pathObj";
// import { isEmpty } from "lodash";
// import helper from "../../utils/helpers";
// import { BsArrowUpShort } from "react-icons/bs";
// import StaffIpModal from "components/geoAccess/StaffIpModal";

// const HROnboardingList = ({ onboardingList, page, allOnboarding, handleEdit, handleView, sort, setSort }) => {
//   const notification = useToastContext();
//   const { t } = useTranslation();
//   const [ipItem, setIpItem] = useState(null);

//   const handelStatusChange = async (item) => {
//     try {
//       const payload = {
//         status: item?.status === "inactive" ? "active" : "inactive",
//       };
//       const path = `${apiPath.onboardingStatus}/${item?._id}`;
//       const result = await apiPut(path, payload);
//       if (result?.status === 200) {
//         notification.success(result.data.message);
//         allOnboarding();
//       }
//     } catch (error) {
//       console.log("error in get all country list==>>>>", error.message);
//     }
//   };

//   const handleDeleteHR = async (id) => {
//     try {
//       const path = `${apiPath.onboardingDelete}/${id}`;
//       const result = await apiDelete(path);
//       if (result?.status === 200) {
//         notification.success(result.data.message);
//         allOnboarding({ deletePage: true });
//       }
//     } catch (error) {
//       console.log("error in delete HR==>>>>", error.message);
//     }
//   };

//   return (
//     <div>
//       <div className="p-3">
//         <div className="border overflow-x-auto relative rounded-lg ">
//           <table className="dark:text-gray-400 w-full text-xs text-left text-[#A5A5A5] ">
//             <thead className="bg-[#E1E6EE] text-xs text-gray-900 border border-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
//               <tr>
//                 <th className="px-6 py-3" scope="col">
//                   Sr no.
//                 </th>
//                 <th scope="col" className="px-6 py-3">
//                   {t("HR_ID")}
//                 </th>
//                 <th scope="col" className="py-3 px-6">
//                   {t("HR_NAME")}
//                 </th>
//                 <th scope="col" className="py-3 px-6">
//                   {t("MOBILE_NUMBER")}
//                 </th>
//                 <th
//                   scope="col"
//                   className="cursor-pointer py-3 px-6 "
//                   onClick={() => {
//                     if (sort.sortBy === "email" && sort.sortType === "asc") {
//                       setSort({
//                         sortType: "desc",
//                         sortBy: "email",
//                       });
//                     } else {
//                       setSort({
//                         sortType: "asc",
//                         sortBy: "email",
//                       });
//                     }
//                   }}
//                 >
//                   <div className="flex justify-start">
//                     <span>{t("EMAIL_ID")}</span>
//                     <span>
//                       {sort.sortType === "asc" && sort.sortBy === "email" && <BsArrowUpShort className="h-4 w-4 " />}
//                       {sort.sortBy === "email" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
//                     </span>
//                   </div>
//                 </th>
//                 <th
//                   className="cursor-pointer py-3 px-6 "
//                   scope="col"
//                   onClick={() => {
//                     if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
//                       setSort({
//                         sortType: "desc",
//                         sortBy: "createdAt",
//                       });
//                     } else {
//                       setSort({
//                         sortType: "asc",
//                         sortBy: "createdAt",
//                       });
//                     }
//                   }}
//                 >
//                   <div className="flex justify-start">
//                     <span>{t("CREATED_DATE")}</span>
//                     <span>
//                       {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
//                       {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 rotate-180 h-4 " />}
//                     </span>
//                   </div>
//                 </th>
//                 <th className="py-3 text-center px-6 " scope="col">
//                   {t("O_STATUS")}
//                 </th>
//                 <th scope="col" className="text-center py-3 px-6 ">
//                   {t("O_ACTION")}
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {onboardingList &&
//                 onboardingList.map((item, i) => {
//                   return (
//                     <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
//                       <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
//                         {i + 1 + 10 * (page - 1)}
//                       </th>
//                       <td className="py-4 px-6 border-r text-gray-900">{item?.hrId}</td>
//                       <td className="border-r py-4 px-6 text-gray-900">{item?.name}</td>
//                       <td className="px-6 border-r py-4 text-gray-900">
//                         +({item?.countryCode}) {item?.mobile}
//                       </td>
//                       <td className="text-gray-900 py-4 px-6 border-r ">{item?.email}</td>
//                       <td className="text-left py-4 px-6 border-r text-gray-900 ">{dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")} </td>
//                       <td className="text-center py-4 px-6 border-r text-gray-900 ">
//                         <label title={`${item?.status === "active" ? "Active" : "Inactive"}`} className="relative inline-flex items-center cursor-pointer">
//                           <input
//                             onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, item, handelStatusChange)}
//                             type="checkbox"
//                             className="sr-only peer"
//                             checked={item?.status === "active"}
//                           />
//                           <div className="peer-focus:ring-0 w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
//                         </label>
//                       </td>
//                       <td className="py-4 px-6 border-l text-gray-900">
//                         <div className="">
//                           <ul className="flex justify-center">
//                             <li className="hover:bg-white px-2 py-2 hover:text-LightBlue" onClick={() => handleEdit(item)}>
//                               <a title="Edit" data-bs-toggle="tooltip" className="transition hover:text-blue-700 duration-150 ease-in-out">
//                                 {" "}
//                                 <AiFillEdit className="w-5 h-5 cursor-pointer text-slate-600" />
//                               </a>
//                             </li>
//                             <li className="py-2 px-2 hover:bg-white hover:text-LightBlue" onClick={() => setIpItem(item)}>
//                               <a title={t("GEO_MANAGE_IPS")}>
//                                 <FiGlobe className="w-5 h-5 cursor-pointer text-slate-600" />
//                               </a>
//                             </li>
//                             <li className="py-2 px-2 hover:bg-white hover:text-LightBlue" onClick={() => handleView(item)}>
//                               <a title="View">
//                                 {" "}
//                                 <AiFillEye className="text-slate-600 cursor-pointer w-5 h-5 " />{" "}
//                               </a>
//                             </li>
//                             <li
//                               onClick={() => {
//                                 helper.alertFunction(
//                                   `Are you sure you want to delete HR '${item?.name}'?`,
//                                   item?._id,
//                                   handleDeleteHR,
//                                   true
//                                 );
//                               }}
//                               className="px-2 py-2 hover:bg-white hover:text-red-500 cursor-pointer"
//                             >
//                               <a title={t("O_DELETE_USER")}>
//                                 <AiFillDelete className="w-5 h-5 text-slate-600 hover:text-red-600" />
//                               </a>
//                             </li>
//                           </ul>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               {isEmpty(onboardingList) ? (
//                 <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
//                   <td className="py-4 px-6 border-r" colSpan={8}>
//                     {t("O_NO_RECORD_FOUND")}
//                   </td>
//                 </tr>
//               ) : null}
//             </tbody>
//           </table>
//         </div>
//       </div>
//       {ipItem && (
//         <StaffIpModal
//           item={ipItem}
//           role="HRAdmin"
//           title={t("GEO_SECTION_HR")}
//           onClose={() => setIpItem(null)}
//         />
//       )}
//     </div>
//   );
// };

// export default HROnboardingList;





// import useToastContext from "hooks/useToastContext";
// import { AiFillEdit, AiFillEye } from "react-icons/ai";
// import { FiGlobe } from "react-icons/fi";
// import { apiPut } from "../../utils/apiFetch";
// import { useTranslation } from "react-i18next";
// import { useState } from "react";
// import dayjs from "dayjs";
// import apiPath from "../../utils/pathObj";
// import { isEmpty } from "lodash";
// import helper from "../../utils/helpers";
// import { BsArrowUpShort } from "react-icons/bs";
// import StaffIpModal from "components/geoAccess/StaffIpModal";

// const HROnboardingList = ({ onboardingList, page, allOnboarding, handleEdit, handleView, sort, setSort }) => {
//   const notification = useToastContext();
//   const { t } = useTranslation();
//   const [ipItem, setIpItem] = useState(null);
//   const handelStatusChange = async (item) => {
//     try {
//       const payload = {
//         status: item?.status === "inactive" ? "active" : "inactive",
//       };
//       const path = `${apiPath.onboardingStatus}/${item?._id}`;
//       const result = await apiPut(path, payload);
//       if (result?.status === 200) {
//         notification.success(result.data.message);
//         allOnboarding();
//       }
//     } catch (error) {
//       console.log("error in get all country list==>>>>", error.message);
//     }
//   };

//   return (
//     <div>
//       <div className="p-3">
//         <div className="border overflow-x-auto relative rounded-lg ">
//           <table className="dark:text-gray-400 w-full text-xs text-left text-[#A5A5A5] ">
//             <thead className="bg-[#E1E6EE] text-xs text-gray-900 border border-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
//               <tr>
//                 <th className="px-6 py-3" scope="col">
//                   Sr no.
//                 </th>
//                 <th scope="col" className="px-6 py-3">
//                   {t("HR_ID")}
//                 </th>
//                 <th scope="col" className="py-3 px-6">
//                   {t("HR_NAME")}
//                 </th>
//                 <th scope="col" className="py-3 px-6">
//                   {t("MOBILE_NUMBER")}
//                 </th>
//                 <th
//                   scope="col"
//                   className="cursor-pointer py-3 px-6 "
//                   onClick={() => {
//                     if (sort.sortBy === "email" && sort.sortType === "asc") {
//                       setSort({
//                         sortType: "desc",
//                         sortBy: "email",
//                       });
//                     } else {
//                       setSort({
//                         sortType: "asc",
//                         sortBy: "email",
//                       });
//                     }
//                   }}
//                 >
//                   <div className="flex justify-start">
//                     <span>{t("EMAIL_ID")}</span>
//                     <span>
//                       {sort.sortType === "asc" && sort.sortBy === "email" && <BsArrowUpShort className="h-4 w-4 " />}
//                       {sort.sortBy === "email" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
//                     </span>
//                   </div>
//                 </th>
//                 <th
//                   className="cursor-pointer py-3 px-6 "
//                   scope="col"
//                   onClick={() => {
//                     if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
//                       setSort({
//                         sortType: "desc",
//                         sortBy: "createdAt",
//                       });
//                     } else {
//                       setSort({
//                         sortType: "asc",
//                         sortBy: "createdAt",
//                       });
//                     }
//                   }}
//                 >
//                   <div className="flex justify-start">
//                     <span>{t("CREATED_DATE")}</span>
//                     <span>
//                       {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
//                       {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 rotate-180 h-4 " />}
//                     </span>
//                   </div>
//                 </th>
//                 <th className="py-3 text-center px-6 " scope="col">
//                   {t("O_STATUS")}
//                 </th>
//                 <th scope="col" className="text-center py-3 px-6 ">
//                   {t("O_ACTION")}
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {onboardingList &&
//                 onboardingList.map((item, i) => {
//                   return (
//                     <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
//                       <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
//                         {i + 1 + 10 * (page - 1)}
//                       </th>
//                       <td className="py-4 px-6 border-r text-gray-900">{item?.hrId}</td>
//                       <td className="border-r py-4 px-6 text-gray-900">{item?.name}</td>
//                       <td className="px-6 border-r py-4 text-gray-900">
//                         +({item?.countryCode}) {item?.mobile}
//                       </td>
//                       <td className="text-gray-900 py-4 px-6 border-r ">{item?.email}</td>
//                       <td className="text-left py-4 px-6 border-r text-gray-900 ">{dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")} </td>
//                       <td className="text-center py-4 px-6 border-r text-gray-900 ">
//                         <label title={`${item?.status === "active" ? "Active" : "Inactive"}`} className="relative inline-flex items-center cursor-pointer">
//                           <input
//                             onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, item, handelStatusChange)}
//                             type="checkbox"
//                             className="sr-only peer"
//                             checked={item?.status === "active"}
//                           />
//                           <div className="peer-focus:ring-0 w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
//                         </label>
//                       </td>
//                       <td className="py-4 px-6 border-l text-gray-900">
//                         <div className="">
//                           <ul className="flex justify-center">
//                             <li className="hover:bg-white px-2 py-2 hover:text-LightBlue" onClick={() => handleEdit(item)}>
//                               <a title="Edit" data-bs-toggle="tooltip" className="transition hover:text-blue-700 duration-150 ease-in-out">
//                                 {" "}
//                                 <AiFillEdit className="w-5 h-5 cursor-pointer text-slate-600" />
//                               </a>
//                             </li>
//                             <li className="py-2 px-2 hover:bg-white hover:text-LightBlue" onClick={() => setIpItem(item)}>
//                               <a title={t("GEO_MANAGE_IPS")}>
//                                 <FiGlobe className="w-5 h-5 cursor-pointer text-slate-600" />
//                               </a>
//                             </li>
//                             <li className=" py-2 px-2hover:bg-white hover:text-LightBlue" onClick={() => handleView(item)}>
//                               <a title="View">
//                                 {" "}
//                                 <AiFillEye className="text-slate-600 cursor-pointer w-5 h-5 " />{" "}
//                               </a>
//                             </li>
//                           </ul>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               {isEmpty(onboardingList) ? (
//                 <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
//                   <td className="py-4 px-6 border-r" colSpan={8}>
//                     {t("O_NO_RECORD_FOUND")}
//                   </td>
//                 </tr>
//               ) : null}
//             </tbody>
//           </table>
//         </div>
//       </div>
//       {ipItem && (
//         <StaffIpModal
//           item={ipItem}
//           role="HRAdmin"
//           title={t("GEO_SECTION_HR")}
//           onClose={() => setIpItem(null)}
//         />
//       )}
//     </div>
//   );
// };

// export default HROnboardingList;
